<label
	*ngIf="isLabel"
	class="label"
	for="{{selectId}}"
>
	{{ label }}
</label>
<form
	[formGroup]="form"
>
		<div [ngClass]="{ 'select-wrapper': selectId != 'selectMeal' }" [class.is-open]="false">
				<select
					#select
					selectbox
					class="select {{ errorClass }} {{ isUnselected }}"
					formControlName="select"
					[attr.aria-label]="selectLabel"
					[id]="selectId"
				>
					<ng-container *ngIf="optionsTranslated">
						<option *ngIf="hasPlaceholder" [ngValue]="null" default selected="true">{{placeholder}}</option>
						<ng-container *ngIf="!isValueComplexObject">
							<option *ngFor="let option of options; trackBy: trackByFn" [value]="option.value">
								{{ option.text }}
							</option>
						</ng-container>
						<ng-container *ngIf="isValueComplexObject">
							<option *ngFor="let option of options; trackBy: trackByFn" [ngValue]="option.value">
								{{ option.text }}
							</option>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="!optionsTranslated">
						<option *ngIf="hasPlaceholder" [ngValue]="null" default selected="true">{{placeholder}}</option>
						<ng-container *ngIf="!isValueComplexObject">
							<option *ngFor="let option of options; " [value]="option.value">
								{{ option.text | ibeadmin:'sync' }}
							</option>
						</ng-container>
						<ng-container *ngIf="isValueComplexObject">
							<option *ngFor="let option of options; " [ngValue]="option.value">
								{{ option.text | ibeadmin:'sync' }}
							</option>
						</ng-container>
					</ng-container>
				</select>

			<!--<ng-container *ngIf="!disabled">
				<select
            #select
						selectbox
						class="select {{ errorClass }} {{ isUnselected }}"
						formControlName="select"
						id="select-indra-label"
				>
					<ng-container *ngIf="optionsTranslated">
						<option *ngIf="hasPlaceholder" [value]="null" default selected="true">{{placeholder}}</option>
						<option *ngFor="let option of options; trackBy: trackByFn" [value]="option.value">
							{{ option.text }}
						</option>
					</ng-container>
					<ng-container *ngIf="!optionsTranslated">
						<option *ngIf="hasPlaceholder" [value]="null" default selected="true">{{placeholder}}</option>
						<option *ngFor="let option of options; " [value]="option.value">
							{{ option.text | ibeadmin:'sync' }}
						</option>
					</ng-container>
				</select>
			</ng-container>-->
		</div>
</form>
<!-- <span
	aria-live="polite"
	class="input-error"
	role="alert"
	*ngIf="form.controls['docType'].invalid && form.touched"
>
		{{ formPersonalDocumentsErrors('docType') | ibeadmin:'sync'}}
</span> -->
